const ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    id
    title
    type
    subtype
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;

const ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    id
    title
    type
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;

export const operationName = 'QuickFindUserDocumentsQuery';

export const quickFindUserDocumentsQuery: '\n  query QuickFindUserDocumentsQuery (\n    $userId: String!,\n    $tenantId: String!,\n    $caller: String!,\n    $maxNumberOfResults: Int!\n  ) {\n    smarts {\n      recommendedObject(\n        recommendationsQuery: {\n          context: {\n            userId: $userId\n            tenantId: $tenantId\n          }, modelRequestParams: {\n            caller: $caller\n            experience: "ConfUserPages"\n          }, \n          requestingUserId: $userId \n          maxNumberOfResults: $maxNumberOfResults\n        }\n      ) {\n        id\n        score\n        reason\n        object {\n          ...ConfluencePageFragment\n          ...ConfluenceBlogPostFragment\n        }\n      }\n    }\n  }\n  \n  fragment ConfluencePageFragment on ConfluencePage {\n    __typename\n    id\n    title\n    type\n    subtype\n    links {\n      base\n      webUi\n    }\n    space {\n      id\n      name\n    }\n  }\n\n  \n  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {\n    __typename\n    id\n    title\n    type\n    links {\n      base\n      webUi\n    }\n    space {\n      id\n      name\n    }\n  }\n\n' = `
  query ${operationName} (
    $userId: String!,
    $tenantId: String!,
    $caller: String!,
    $maxNumberOfResults: Int!
  ) {
    smarts {
      recommendedObject(
        recommendationsQuery: {
          context: {
            userId: $userId
            tenantId: $tenantId
          }, modelRequestParams: {
            caller: $caller
            experience: "ConfUserPages"
          }, 
          requestingUserId: $userId 
          maxNumberOfResults: $maxNumberOfResults
        }
      ) {
        id
        score
        reason
        object {
          ...ConfluencePageFragment
          ...ConfluenceBlogPostFragment
        }
      }
    }
  }
  ${ConfluencePageFragment}
  ${ConfluenceBlogPostFragment}
`;
